export enum SessionStorageKey {
    TOKEN = 'TOKEN',
    TOKEN_TYPE = 'TOKEN_TYPE',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
    EXPIRES_IN = 'EXPIRES_IN',
    LAST_STEP = 'LAST_STEP',
    USER = 'USER',
    PRINTER_CONFIG = 'PRINTER_CONFIG',
}
